import type { GameKindAdapter } from "../shared/adapter";
import { compileCardTurn } from "./compiler";
import { evaluateCardTurn } from "./evaluator";
import { repairCommandsForCardTurn } from "./repair";
import { parseCardTurnSpec, type CardTurnSpec } from "./spec";

export const cardTurnAdapter: GameKindAdapter = {
  kind: "card-turn",
  briefHints: ["card duel", "card game", "highest card wins", "war", "card battle"],
  promptSchemaLine: '{"kind":"card-turn","params":{"deckSize":integer 10-20,"roundsToWin":integer (more than half of deckSize) to deckSize,"players":1 or 2 (2 = local duel versus a friend, both hands on one screen)}}',
  parseSpec: parseCardTurnSpec,
  compile: (spec) => compileCardTurn(spec as CardTurnSpec),
  evaluate: (spec) => evaluateCardTurn(spec as CardTurnSpec),
  repairCommandsFor: (spec, failedReceipt) => repairCommandsForCardTurn(spec as CardTurnSpec, failedReceipt),
};

export type { CardTurnSpec } from "./spec";
